import React, { useState, useEffect, useRef } from 'react';

const AutocompleteInput = ({ 
  value, 
  onChange, 
  onSelect,
  options, 
  placeholder, 
  disabled,
  name,
  required
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (value && options.length > 0) {
      const filtered = options.filter(option =>
        option.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  }, [value, options]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    onChange(e);
    setShowOptions(true);
  };

  const handleOptionClick = (option) => {
    if (onSelect) {
      onSelect(option);
    } else {
      onChange({ target: { name, value: option } });
    }
    setShowOptions(false);
  };

  const handleFocus = () => {
    if (!disabled && options.length > 0) {
      setShowOptions(true);
    }
  };

  return (
    <div className="autocomplete-wrapper" ref={wrapperRef}>
      <input
        type="text"
        name={name}
        value={value}
        onChange={handleInputChange}
        onFocus={handleFocus}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        autoComplete="off"
      />
      {showOptions && filteredOptions.length > 0 && (
        <ul className="autocomplete-options">
          {filteredOptions.slice(0, 10).map((option, index) => (
            <li
              key={index}
              onClick={() => handleOptionClick(option)}
              className="autocomplete-option"
            >
              {option}
            </li>
          ))}
          {filteredOptions.length > 10 && (
            <li className="autocomplete-info">
              +{filteredOptions.length - 10} mais resultados...
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default AutocompleteInput;
